<template>
    <div class="salesReport">
        ====================》这是salesReport页
    </div>
</template>
<script>
export default {
    name:'salesReport',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// salesReport.vue?82edef66